module.exports = __webpack_public_path__ + "img/avatar.c86140a8.svg";